import React from "react";
import Table from "@/components/reports";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import { i18n } from "@/utils/i18n";

const AuditedReports: React.FC = () => {
    return <Table reviewStatus="1,2,3" title={i18n.t("auditedReportOverview")} />;
};

export default withErrorBoundary({ component: "Audited reports page" })(AuditedReports);
